const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

export const buildSelectors = (mainRedux, filterStatePropKey = 'psqlcustomers') => {
	const { selectFiltersState } = mainRedux.selectors;

	const selectPsqlCustomerFilterState = sliceState => {
		const filtersState = selectFiltersState(sliceState);
		const customers = filtersState[filterStatePropKey] || EMPTY_OBJECT;
		return customers;
	};

	const selectPsqlCustomerList = sliceState => {
		const state = selectPsqlCustomerFilterState(sliceState);
		const { list = EMPTY_ARRAY } = state;
		return list;
	};
	const selectPsqlCustomerListCount = sliceState => {
		const state = selectPsqlCustomerFilterState(sliceState);
		const { listCount = 0 } = state;
		return listCount;
	};

	const selectPsqlCustomerSelectedList = sliceState => {
		const state = selectPsqlCustomerFilterState(sliceState);
		const { selected = EMPTY_ARRAY } = state;
		return selected;
	};

	const selectPsqlCustomerSelectedListCount = sliceState => {
		const state = selectPsqlCustomerFilterState(sliceState);
		const { selectedCount = 0 } = state;
		return selectedCount;
	};

	const selectPsqlCustomerIsLoading = sliceState => {
		const state = selectPsqlCustomerFilterState(sliceState);
		const { isLoading = false } = state;
		return isLoading;
	};

	const selectPsqlCustomerIsLoaded = sliceState => {
		const state = selectPsqlCustomerFilterState(sliceState);
		const { isLoaded = false } = state;
		return isLoaded;
	};

	const selectPsqlCustomerLoadErrorMessage = sliceState => {
		const state = selectPsqlCustomerFilterState(sliceState);
		const { loadErrorMessage } = state;
		return loadErrorMessage;
	};

	return {
		selectPsqlCustomerFilterState,
		selectPsqlCustomerList,
		selectPsqlCustomerListCount,
		selectPsqlCustomerSelectedList,
		selectPsqlCustomerSelectedListCount,
		selectPsqlCustomerIsLoading,
		selectPsqlCustomerIsLoaded,
		selectPsqlCustomerLoadErrorMessage
	};
};

export default {
	buildSelectors
};
